// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"e64b3397","126":"17fcf933","492":"e9a9649b","608":"110de919","997":"3d2654cb"}[chunkId] + ".chunk.js";
};